// src/components/TechnicalSecurity.jsx

import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";


// Sample icons (replace with actual images or SVGs)
import techIcon from "../../Assets/Home/serTech.png";
import cctvIcon from "../../Assets/Home/cctv.png";
import controlIcon from "../../Assets/Home/control.png";

const techServices = [
  {
    icon: techIcon,
    title: "Technical Security",
    description:
      "Technical security refers to a series of techniques used for authentication and protection against theft of sensitive data and information.",
  },
  {
    icon: cctvIcon,
    title: "CCTV Systems Network",
    description:
      "Modern CCTV systems can be monitored through mobile phone apps which allow people to view live footage of their house from anywhere.",
  },
  {
    icon: controlIcon,
    title: "All Control Systems",
    description:
      "All Control Systems is a full-service company providing Integrated Security Management Systems for a wide variety of clients.",
  },
];

const TechnicalSecurity = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="tech-security-wrapper">
          <h2 className="hea-services">Our Services</h2>
        <div className="tech-security-cards">
          
          {techServices.map((service, index) => (
            <div className="tech-card" key={index}>
              <div className="icon-wrapper">
                <img
                  src={service.icon}
                  alt={service.title}
                  className="tech-icon"
                />
              </div>

              <h3>{service.title}</h3>
              <p className="ser-desc">{service.description}</p>
            </div>
          ))}
          
          <div onClick={() => navigate("/services")}>
            
            <div className="cta">
              
              <span>More Services</span>
              <svg width="15px" height="10px" viewBox="0 0 13 10">
                <path d="M1,5 L11,5"></path>
                <polyline points="8 1 12 5 8 9"></polyline>
              </svg>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TechnicalSecurity;
